import { useCallback } from 'react';
import { useFiltrosRelatorio } from '@/features/relatorios/hooks/useFiltrosRelatorio';

/**
 * Estado dos filtros de UMA aba dos relatórios: `[filtros, aplicar, limpar]`.
 * `aplicar` mescla um pedaço (vários campos de uma vez); `limpar` volta tudo
 * ao padrão. Persistido por aba em `sessionStorage` (via
 * `useFiltrosRelatorio`): trocar de aba ou recarregar a página não perde
 * o que foi escolhido.
 */
export function useFiltrosAba<T extends object>(
  chave: string,
  padrao: T,
): [T, (parcial: Partial<T>) => void, () => void] {
  const [filtros, setFiltro, limpar] = useFiltrosRelatorio(chave, padrao);
  const aplicar = useCallback(
    (parcial: Partial<T>) => {
      for (const k of Object.keys(parcial) as Array<keyof T>) {
        setFiltro(k, parcial[k] as T[keyof T]);
      }
    },
    [setFiltro],
  );
  return [filtros, aplicar, limpar];
}
